import SupportAgentTwoToneIcon from "@mui/icons-material/SupportAgentTwoTone";
import HeadsetTwoToneIcon from "@mui/icons-material/HeadsetTwoTone";
import PollIcon from "@mui/icons-material/Poll";
import PollTwoToneIcon from "@mui/icons-material/PollTwoTone";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import EngineeringTwoToneIcon from "@mui/icons-material/EngineeringTwoTone";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
// import ModeStandbyTwoToneIcon from "@mui/icons-material/ModeStandbyTwoTone";
import GroupsIcon from "@mui/icons-material/Groups";
// import HotTubIcon from "@mui/icons-material/HotTub";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SpatialAudioOffIcon from "@mui/icons-material/SpatialAudioOff";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import QuizIcon from "@mui/icons-material/Quiz";
import DescriptionIcon from "@mui/icons-material/Description";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import BusinessIcon from "@mui/icons-material/Business";

export const DASHBOARD_SECTIONS = {
  callCenter: {
    title: "Call Center",
    checkAccess: (modules, isAdmin) =>
      isAdmin || modules?.some((m) => m.startsWith("call-center")),
    features: [
      {
        module: ["call-center-admin"],
        title: "Call Center Admin",
        icon: ManageAccountsTwoToneIcon,
        link: "/CDA/callCenter/campaigns",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-admin"],
        title: "Campaign Planning (Deprecated)",
        icon: TrackChangesIcon,
        link: "/CDA/CallCenter/CampaignPlanningMain",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-admin"],
        title: "Campaign Planning 2",
        icon: TrackChangesIcon,
        link: "/CDA/CallCenter/CampaignPlanning2",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-team-leader"],
        title: "Call Center Coaching",
        icon: ModelTrainingIcon,
        link: "/CDA/CallCenter/Coaching/ListOfScoreCards",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-manager"],
        title: "Call Center Attendance",
        icon: GroupsIcon,
        link: "/CDA/CallCenter/Attendance",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-user"],
        title: "Call Center",
        icon: SupportAgentTwoToneIcon,
        link: "/CDA/AgentHome/CampaignList",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-user"],
        title: "Evaluations",
        icon: QuizIcon,
        link: "/CDA/AgentEvaluationsHome",
        hideFromAdmin: false,
      },
      {
        module: [
          "call-center-admin",
          "call-center-team-leader",
          "call-center-manager",
        ],
        title: "Reports",
        icon: QueryStatsIcon,
        link: "/reports",
        hideFromAdmin: false,
      },
    ],
  },
  clientServices: {
    title: "Client Services",
    checkAccess: (modules, isAdmin) =>
      isAdmin ||
      modules?.some((m) =>
        ["survey-user", "survey-admin", "call-center-admin"].includes(m),
      ),
    features: [
      {
        module: ["survey-user"],
        title: "Surveys",
        icon: PollIcon,
        link: "/CDA/survey",
        hideFromAdmin: false,
      },
      {
        module: ["survey-admin"],
        title: "Surveys Admin",
        icon: PollTwoToneIcon,
        link: "/CDA/surveyAdmin",
        hideFromAdmin: false,
      },
      {
        module: ["call-center-admin"],
        title: "Reports",
        icon: QueryStatsIcon,
        link: "/ClientServicesReports",
        hideFromAdmin: false,
      },
    ],
  },
  qa: {
    title: "Quality Assurance",
    checkAccess: (modules, isAdmin) =>
      isAdmin || modules?.some((m) => ["qa-user", "qa-admin"].includes(m)),
    features: [
      {
        module: ["qa-admin"],
        title: "QA Manager",
        icon: AssignmentIndIcon,
        link: "/CDA/inbound/manager",
        hideFromAdmin: true,
      },
      {
        module: ["qa-user"],
        title: "QA User",
        icon: SpatialAudioOffIcon,
        link: "/CDA/inbound/user",
        hideFromAdmin: false,
      },
      {
        module: ["qa-admin"],
        title: "QA Admin",
        icon: AdminPanelSettingsIcon,
        link: "/CDA/inbound/admin",
        hideFromAdmin: false,
      },
      {
        module: ["qa-user"],
        title: "QA (Legacy)",
        icon: HeadsetTwoToneIcon,
        link: "/CDA/QaAgentHome",
        hideFromAdmin: true,
      },
      {
        module: ["qa-admin"],
        title: "QA Admin Console (Legacy)",
        icon: EngineeringTwoToneIcon,
        link: "/CDA/QaConsole/QaQueues",
        hideFromAdmin: false,
      },
      {
        module: ["qa-admin", "qa-user"],
        title: "Reports",
        icon: QueryStatsIcon,
        link: "/QAreports",
        hideFromAdmin: false,
      },
      {
        module: ["qa-admin"],
        title: "Extracts",
        icon: DescriptionIcon,
        link: "/extracts",
        hideFromAdmin: false,
      },
    ],
  },
  admin: {
    title: "Admin",
    checkAccess: (modules, isAdmin) => isAdmin,
    features: [
      {
        module: ["admin"],
        title: "User Management",
        icon: SupervisedUserCircleIcon,
        link: "/UserManagement",
        hideFromAdmin: false,
      },
      {
        module: ["admin"],
        title: "Companies Management",
        icon: BusinessIcon,
        link: "/CompaniesManagement",
        hideFromAdmin: false,
      },
    ],
  },
};
